import {
  library,
} from '@fortawesome/fontawesome-svg-core'
import {
  faArrowUp,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faArrowRightLong,
  faArrowRight,
  faArrowLeft,
  faStar,
  faCaretDown,
  faCaretSquareDown,
  faCaretSquareUp,
  faQuestionCircle,
  faPlane,
  faEnvelope,
  faBus,
  faSearch,
  faPlus,
  faPlusCircle,
  faMinus,
  faTimes,
  faPhone,
  faTag,
  faUser,
  faBan,
  faInfoCircle,
  faExclamationCircle,
  faBars,
  faMapLocationDot,
  faMap,
  faSun,
  faLocationDot,
  faCircleXmark,
  faCircleCheck,
  faCircle,
  faVideo,
  faClock,
  faCalendar,
  faHotel,
  faRotateLeft,
  faCheck,
  faSunBright,
  faTaxiBus,
  faLink,
  faCopy,
  faImage,
  faImages,
  faUtensils,
  faTableCellsLarge,
  faTags,
  faArchway,
  faBadgePercent,
  faPersonBiking,
  faPersonHiking,
  faCity,
  faShip,
  faCalendarXmark,
  faListUl,
  faRotateReverse,
  faGlobeAmericas,
  faUserGroup,
  faPlaneSlash,
} from '@fortawesome/pro-solid-svg-icons'

export default defineNuxtPlugin(() => {
  library.add({
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faArrowRightLong,
    faArrowRight,
    faArrowLeft,
    faStar,
    faCaretDown,
    faCaretSquareDown,
    faCaretSquareUp,
    faPlane,
    faEnvelope,
    faBus,
    faSearch,
    faPlus,
    faPlusCircle,
    faMinus,
    faTimes,
    faPhone,
    faTag,
    faUser,
    faBan,
    faInfoCircle,
    faLink,
    faExclamationCircle,
    faBars,
    faCopy,
    faMapLocationDot,
    faMap,
    faSun,
    faLocationDot,
    faCircleXmark,
    faCircleCheck,
    faCircle,
    faVideo,
    faClock,
    faCalendar,
    faHotel,
    faRotateLeft,
    faCheck,
    faSunBright,
    faTaxiBus,
    faImage,
    faImages,
    faUtensils,
    faTableCellsLarge,
    faTags,
    faQuestionCircle,
    faArchway,
    faBadgePercent,
    faPersonBiking,
    faPersonHiking,
    faCity,
    faShip,
    faCalendarXmark,
    faListUl,
    faArrowUp,
    faRotateReverse,
    faGlobeAmericas,
    faUserGroup,
    faPlaneSlash,
  })
})
